import {Actions, createEffect, ofType, ROOT_EFFECTS_INIT} from '@ngrx/effects';
import {CountryApi} from '@modules/country/api/country.api';
import {catchError, EMPTY, switchMap, tap} from 'rxjs';
import {Injectable} from '@angular/core';
import {CountryService} from "@modules/country/services/country.service";

@Injectable()
export class CountryInitializerEffects {
  initCountries$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROOT_EFFECTS_INIT),
      switchMap(() => this.countryApi.get$()),
      tap(countries => this.countryService.dispatchSetEntities(countries)),
      catchError(e => {
        console.error(e);

        this.countryService.dispatchClearEntitiesAction()

        return EMPTY;
      }),
    )
  }, {dispatch: false});

  constructor(
    private actions$: Actions,
    private countryApi: CountryApi,
    protected readonly countryService: CountryService
  ) {
  }
}
